import React, { createContext, useContext, useState } from 'react';

// ------ Context
interface CounterContextType {
	count: number;
	increment: () => void;
	decrement: () => void;
}

const CounterContext = createContext<CounterContextType>({
	count: 0,
	increment: () => {},
	decrement: () => {},
});

// ------ Provider
interface ICounterProvider {
	children: React.ReactNode;
}

const CounterProvider = ({ children }: ICounterProvider) => {
	const [count, setCount] = useState(0);
	const increment = () => setCount((count) => count + 1);
	const decrement = () => setCount((count) => count - 1);

	const contextValue: CounterContextType = {
		count,
		increment,
		decrement,
	};

	return (
		<CounterContext.Provider value={contextValue}>
			{children}
		</CounterContext.Provider>
	);
};

// ------ Components
const IncrementCounter = () => {
	const { increment } = useContext(CounterContext);
	return <button onClick={increment}>Increment</button>;
};

const DecrementCounter = () => {
	const { decrement } = useContext(CounterContext);
	return <button onClick={decrement}>Decrement</button>;
};

const ShowResult = () => {
	const { count } = useContext(CounterContext);
	return <span className="mt-2">{count}</span>;
};

const App = () => {
	return (
		<CounterProvider>
			<div className="flex items-center gap-3">
				<IncrementCounter />
				<ShowResult />
				<DecrementCounter />
			</div>
		</CounterProvider>
	);
};

export default App;
